import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/regions";

const regionApi = {
  getRegions(params?: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
};


export default regionApi;
